import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'messageformat' })
export class MessageFormatPipe implements PipeTransform {
  transform(input: string | number | boolean, args: string[]): string {
    const message = args[0];
    const replacement = args[1];
    return message.replace(replacement, '' + input);
  }
}
